import {ChangeDetectorRef, Component, forwardRef, HostListener, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractCheckboxInput} from "../abstract-checkbox-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIPopCheckboxInputComponent),
            multi: true
        }
    ],
    selector: "fui-pop-checkbox-input",
    styleUrls: ["./pop-checkbox-input.component.scss"],
    templateUrl: "./pop-checkbox-input.component.html",
    standalone: false
})
export class FUIPopCheckboxInputComponent extends FUIAbstractCheckboxInput {
    @Input() allowLabelMarkup: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    override mouseClick(event?: MouseEvent): void {
        // stopPropagation to stop the popup in the MultiSelectControl to close
        event.stopPropagation();

        // (shortTouch) on the fascia performs click function (see template) - cannot attach directives to host
    }

    /**
     * Focus on mouse-down - required for multi-select on long click to enabled option open action
     */
    @HostListener("mousedown", ["$event"])
    @HostListener("touchstart", ["$event"])
    public onMouseDown(event: MouseEvent | TouchEvent): void {
        this.focus();
        event.stopPropagation();
        event.preventDefault();
    }

}
